<template>
  <div id="analytics">
    <span id="mini-text" v-html="htmlTxt"> </span>
    <div>
      <h4>word counts</h4>
      <div id="word-count">
        <p v-for="w in words" :key="w[0]">
          <span @click="hl(w[0])" class="link" style="font-weight:bold">
            {{ w[0] }}</span
          >
          :
          <span>{{ w[1] }}</span>
        </p>
      </div>
    </div>

    <div id="query">
      <h4>query:</h4>
      <span v-if="query">
        <span
          v-for="(q, i) in query"
          :key="i"
          @click="hl({ query })"
          class="link"
          style="background-color: #777"
        >
          <span :style="{ color: q.color }">{{ q.op }}</span>
          <span>
            {{ q.val }}
          </span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Constants } from 'regexp-i18n'
import { skipWords } from '@/assets/constants.js'

export default {
  props: ['text', 'query'],

  data() {
    return {
      htmlTxt: null,
      words: null,
      skipWords,
    }
  },

  methods: {
    ...mapActions({
      sleep: 'util/sleep',
    }),

    analyze() {
      if (!this.text) return
      const words = {}
      const rgx = new RegExp(
        '(\r|\n)+|([' + Constants.LETTERS_AND_DIACRITICS + ']{2,})',
        'ug',
      )
      this.htmlTxt = this.text.replace(rgx, (w, p1, p2) => {
        // replace newlines with br
        if (p1) {
          return '<br />'
        }
        const wk = w.toLowerCase()
        if (this.skipWords.includes(wk)) return
        words[wk] = words[wk] ? words[wk] + 1 : 1
        return `<span class="w-${wk}">${w}</span>`
      })
      this.words = Object.entries(words).sort((a, b) => a[1] < b[1])
    },

    async hl(w) {
      if (w.query) {
        w = w.query.reduce(
          (a, v) =>
            v.op !== '-'
              ? [...a, ...v.val.replace(/["'()]+/g, '').split(/\s+/)]
              : a,
          [],
        )
      } else {
        w = [w]
      }

      const hled = [...document.getElementsByClassName('h1l1t3')]
      while (hled.length) {
        hled.shift().classList.remove('h1l1t3')
      }

      const words = w.reduce((a, v) => {
        let ws = document.getElementsByClassName(`w-${v}`)
        return [...a, ...ws]
      }, [])
      for (let i = 0; i < words.length; i++) {
        words[i].classList.add('h1l1t3')
        await this.sleep(10)
      }
    },
  },

  async created() {
    await this.$nextTick()
    this.analyze()
  },
}
</script>

<style scoped>
#analytics {
  display: flex;
}
#query {
  width: 200px;
  flex: auto;
  margin: 4px;
  padding: 4px;
  background-color: #444;
  border: solid black 1px;
  color: #eee;
  overflow-y: scroll;
}
#mini-text {
  flex: auto;
  max-width: 120px;
  margin: 4px;
  padding: 4px;
  font-size: 0.05em;
  line-height: 0.3em;
  overflow-y: scroll;
}
#mini-text >>> .h1l1t3 {
  font-size: 12px;
  line-height: 1em;
  color: #9f9;
}

#word-count {
  flex: auto;
  max-width: 120px;
  max-height: 80vh;
  overflow-y: scroll;
}
h4 {
  margin: 0px;
  padding: 0px;
}
p {
  font-size: 10px;
  line-height: 1px;
}
</style>
